import React from "react";

const Footer = () => {
  return (
    <footer className="border-t border-orange-100 bg-white">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4 p-6">
        
        <p className="text-sm text-gray-600 text-center md:text-left">
          © {new Date().getFullYear()} TiffinTap. All rights reserved.
        </p>

        <div className="flex gap-6">
          <a
            href="https://www.tiffintap.com/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-orange-500 hover:text-orange-600 hover:underline transition"
          >
            Privacy Policy
          </a>

          <a
            href="https://www.tiffintap.com/terms-of-service"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-orange-500 hover:text-orange-600 hover:underline transition"
          >
            Terms of Service
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 